import { memo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography, Paper, ButtonBase } from "@mui/material";
import { getDeliveryStatus } from "../utils/functions";

const DeliveryItem = ({ delivery }) => {
  let navigate = useNavigate();
  const [status] = useState(
    getDeliveryStatus().find((status) => delivery.status === status.system_name)
  );

  return (
    <>
      <Paper
        elevation={0}
        sx={{
          p: 0.2,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          borderRadius: "0px !important",
          cursor: "pointer",
          transition: "transform 0.1s ease-in-out, filter 0.1s ease-in-out",
          "&:active": {
            transform: "scale(0.98)",
            filter: "brightness(0.95)",
          },
          WebkitTapHighlightColor: "transparent",
        }}
        onClick={(event) => {
          navigate(`/driver/my-routes/${delivery.id}`);
        }}
      >
        <Box>
          <Typography variant="caption" color="text.secondary">
            CREADA: {delivery.created_at}
          </Typography>
          <Typography variant="body2" sx={{ fontWeight: "bolder !important" }}>
            ASIGNADA: {delivery.assigned_at}
          </Typography>
          <Typography variant="body2" sx={{ fontWeight: "bolder !important" }}>
            ORDEN: {delivery.order}
          </Typography>
          <Typography variant="body2" sx={{ fontWeight: "bolder !important" }}>
            CLIENTE: {delivery.client}
          </Typography>
          <Typography
            variant="caption"
            sx={{ fontWeight: "bolder !important" }}
          >
            {delivery.address}
          </Typography>
        </Box>
        <Box
          sx={{
            minWidth: "5.5rem",
            backgroundColor: `${status.color}`,
            p: "24px 26px",
            borderRadius: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            alignSelf: "stretch",
          }}
        >
          <Typography
            variant="body1"
            sx={{
              fontWeight: "bolder !important",
              color: "white",
              fontSize: "1.2rem !important",
            }}
          >
            {status.user_name}
          </Typography>
        </Box>
      </Paper>
    </>
  );
};

export default memo(DeliveryItem);
